// #3543 - the longest a single "Wrong test?" request (getRide, reread-test, getTest) may
// take before the scribe's sheet is handed back. scribe-fe's axios has no global timeout
// (and we do not set one: the scoring writes must never be cut short), so these three
// calls opt in per request, through the generated client's axios options. Without it a
// hung call on show wifi leaves the sheet locked (#3542) until the browser gives up.
export const REREAD_REQUEST_TIMEOUT_MS = 15000;

// Fresh options per request (a signal is single-use). An AbortController + timer rather
// than axios' own `timeout` (it holds on every adapter, XHR in the browser, fetch, the
// test interceptor) and rather than AbortSignal.timeout (missing on older tablet Safari).
// The abort rejects the call with ERR_CANCELED.
export const rereadRequestOptions = (ms = REREAD_REQUEST_TIMEOUT_MS) => {
  const controller = new AbortController();
  setTimeout(() => controller.abort(), ms);
  return { signal: controller.signal };
};

// Our signal is the only thing that cancels these calls, so a cancel IS the timeout. A
// native axios timeout (ECONNABORTED / ETIMEDOUT) is counted too.
export function isRequestTimeout(err) {
  const code = err?.code ?? err?.cause?.code;
  return code === "ERR_CANCELED" || code === "ECONNABORTED" || code === "ETIMEDOUT";
}
